import { render } from "./AccountViewFullKit.vue?vue&type=template&id=d37727ca"
import script from "./AccountViewFullKit.vue?vue&type=script&lang=js"
export * from "./AccountViewFullKit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__